// User Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';
import { dedupedGet } from '../../utils/api/dedupedFetch';

export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';
export const GET_USERS_RESET = 'GET_USERS_RESET';

export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAIL = 'GET_USER_BY_ID_FAIL';
export const GET_USER_BY_ID_RESET = 'GET_USER_BY_ID_RESET';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';
export const CREATE_USER_RESET = 'CREATE_USER_RESET';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export const UPDATE_USER_RESET = 'UPDATE_USER_RESET';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';
export const DELETE_USER_RESET = 'DELETE_USER_RESET';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET';

// Shareable Users
export const GET_SHAREABLE_USERS = 'GET_SHAREABLE_USERS';
export const GET_SHAREABLE_USERS_SUCCESS = 'GET_SHAREABLE_USERS_SUCCESS';
export const GET_SHAREABLE_USERS_FAIL = 'GET_SHAREABLE_USERS_FAIL';
export const GET_SHAREABLE_USERS_RESET = 'GET_SHAREABLE_USERS_RESET';

// Resend Invitation
export const RESEND_INVITATION = 'RESEND_INVITATION';
export const RESEND_INVITATION_SUCCESS = 'RESEND_INVITATION_SUCCESS';
export const RESEND_INVITATION_FAIL = 'RESEND_INVITATION_FAIL';
export const RESEND_INVITATION_RESET = 'RESEND_INVITATION_RESET';

// Action Creators
export const getUsers = (params) => ({
  type: GET_USERS,
  params,
});

export const getUsersSuccess = (response) => ({
  type: GET_USERS_SUCCESS,
  response,
});

export const getUsersFail = (response) => ({
  type: GET_USERS_FAIL,
  response,
});

export const getUsersReset = () => ({
  type: GET_USERS_RESET,
});

export const getUserByIdReset = () => ({
  type: GET_USER_BY_ID_RESET,
});

export const createUserReset = () => ({
  type: CREATE_USER_RESET,
});

export const updateUserReset = () => ({
  type: UPDATE_USER_RESET,
});

export const deleteUserReset = () => ({
  type: DELETE_USER_RESET,
});

export const changePasswordReset = () => ({
  type: CHANGE_PASSWORD_RESET,
});

export const resendInvitationReset = () => ({
  type: RESEND_INVITATION_RESET,
});

// Thunk Actions
export const getUsersApi = (data) => {
	return (dispatch) => {
		dispatch(getUsers());
		const paramKey = JSON.stringify(data || {});
		dedupedGet(`users:${paramKey}`, () =>
			axios.get(`${config.api.base_url}/users`, {
				params: data,
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch(getUsersSuccess(response.data)))
			.catch((error) => dispatch(getUsersFail(error.response?.data || error.message)));
	};
};

export const getUserByIdApi = (id) => {
	return (dispatch) => {
		dispatch({ type: GET_USER_BY_ID });
		dedupedGet(`userById:${id}`, () =>
			axios.get(`${config.api.base_url}/users/${id}`, {
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch({ type: GET_USER_BY_ID_SUCCESS, response: response.data }))
			.catch((error) => dispatch({ type: GET_USER_BY_ID_FAIL, response: error.response?.data || error.message }));
	};
};

export const createUserApi = (data) => {
	return (dispatch) => {
		dispatch({ type: CREATE_USER });
		axios
			.post(`${config.api.base_url}/users`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const createUserData = response.data;
				dispatch({ type: CREATE_USER_SUCCESS, response: createUserData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: CREATE_USER_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const updateUserApi = (id, data) => {
	return (dispatch) => {
		dispatch({ type: UPDATE_USER });
		axios
			.post(`${config.api.base_url}/users/${id}`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const updateUserData = response.data;
				dispatch({ type: UPDATE_USER_SUCCESS, response: updateUserData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: UPDATE_USER_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const deleteUserApi = (id) => {
	return (dispatch) => {
		dispatch({ type: DELETE_USER });
		axios
			.post(`${config.api.base_url}/users/delete/${id}`, { id }, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deleteUserData = response.data;
				dispatch({ type: DELETE_USER_SUCCESS, response: deleteUserData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: DELETE_USER_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

// Shareable Users Action Creators
export const getShareableUsersSuccess = (response) => ({
	type: GET_SHAREABLE_USERS_SUCCESS,
	response,
});

export const getShareableUsersFail = (response) => ({
	type: GET_SHAREABLE_USERS_FAIL,
	response,
});

export const getShareableUsersReset = () => ({
	type: GET_SHAREABLE_USERS_RESET,
});

export const getShareableUsersApi = (search = '', { excludeProjectId, excludeChatId } = {}) => {
	return (dispatch) => {
		dispatch({ type: GET_SHAREABLE_USERS });
		const params = { search };
		if (excludeProjectId) params.excludeProjectId = excludeProjectId;
		if (excludeChatId) params.excludeChatId = excludeChatId;
		return axios
			.get(`${config.api.base_url}/users/shareable`, {
				params,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				dispatch(getShareableUsersSuccess(response.data));
				return response.data;
			})
			.catch((error) => {
				dispatch(getShareableUsersFail(error.response?.data || error.message));
				throw error;
			});
	};
};

export const changePasswordApi = (data) => {
	return (dispatch) => {
		dispatch({ type: CHANGE_PASSWORD });
		axios
			.post(`${config.api.base_url}/users/change-password`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const changePasswordData = response.data;
				dispatch({ type: CHANGE_PASSWORD_SUCCESS, response: changePasswordData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: CHANGE_PASSWORD_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const resendInvitationApi = (id) => {
	return (dispatch) => {
		dispatch({ type: RESEND_INVITATION });
		axios
			.post(`${config.api.base_url}/users/resend-invitation/${id}`, {}, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const resendData = response.data;
				dispatch({ type: RESEND_INVITATION_SUCCESS, response: resendData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: RESEND_INVITATION_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

